import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import OrderArtworkFrameItem from "../../Components/OrderItems/OrderArtworkFrameItem";
import OrderArtworkItem from "../../Components/OrderItems/OrderArtworkItem";
import OrderFrameItem from "../../Components/OrderItems/OrderFrameItem";
import OrderUserArtworkFrameItem from "../../Components/OrderItems/OrderUserArtworkFrameItem";
import OrderUserArtworkItem from "../../Components/OrderItems/OrderUserArtworkItem";
import { Link, useParams } from "react-router-dom";

const Order = () => {
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [order, setOrder] = useState<any>();
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const order = await Parse.Cloud.run("getOrder", {
          orderId: params.orderId,
        });
        if (order) setOrder(order);
      } catch (error) {
        console.error("Error fetching order:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchOrder();
  }, [params.orderId]);
  const [subtotal, setSubtotal] = useState(0);
  useEffect(() => {
    setSubtotal(0);
    if (order)
      order.get("items").forEach((item: any) => {
        setSubtotal((current) => current + item.quantity);
      });
  }, [order]);
  return (
    <Fragment>

      <Container sx={{ py: 4 }}>
        <Typography variant="h5" component="h1">
          Order Details
        </Typography>
        {order && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 400 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order Date</TableCell>
                  <TableCell align="center">Order number</TableCell>
                  <TableCell align="center">Receiver name</TableCell>
                  <TableCell align="center">Total</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  key={order.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {order.get("createdAt").toDateString()}
                  </TableCell>
                  <TableCell align="center">
                    {order.get("orderNumber")}
                  </TableCell>
                  <TableCell align="center">
                    {order.get("receiverName")}
                  </TableCell>
                  <TableCell align="center">
                    £{order.get("totalAmount").toFixed(2)}
                  </TableCell>
                  <TableCell align="center">proc</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}{" "}
        <br />
        <Typography variant="h5" component="h1">
          Shipping Address
        </Typography>
        {order && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 400 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Town or city</TableCell>
                  <TableCell align="center">line 1</TableCell>
                  <TableCell align="center">line 2</TableCell>
                  <TableCell align="center">Postal code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  key={order.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {order.get("shippingAddress").city}
                  </TableCell>
                  <TableCell align="center">
                    {order.get("shippingAddress").line1}
                  </TableCell>
                  <TableCell align="center">
                    {order.get("shippingAddress").line2 || "-"}
                  </TableCell>
                  <TableCell align="center">
                    {order.get("shippingAddress").postal_code}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <br />
        <Typography variant="h5" component="h1">
          Items
        </Typography>
        {order && order.get("items").length && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 400 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Picture</TableCell>
                  <TableCell align="center">Name</TableCell>
                  <TableCell align="center">Dimensions</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                  <TableCell align="center">Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order
                  .get("items")
                  .toSorted((a: any, b: any) => {
                    if (a.itemId < b.itemId) return -1;
                    if (a.itemId > b.itemId) return 1;
                    return 0;
                  })
                  .map((item: any) => {
                    if (item.type === "Artwork") {
                      return <OrderArtworkItem item={item} />;
                    }
                    if (item.type === "Frame") {
                      return <OrderFrameItem item={item} />;
                    }
                    if (item.type === "UserArtwork") {
                      return <OrderUserArtworkItem item={item} />;
                    }
                    if (item.type === "ArtworkFrame") {
                      return <OrderArtworkFrameItem item={item} />;
                    }
                    if (item.type === "UserArtworkFrame") {
                      return <OrderUserArtworkFrameItem item={item} />;
                    }
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Fragment>
  );
};

export default Order;
